export var SpinnerTypes;
(function (SpinnerTypes) {
    SpinnerTypes["regular"] = "regular";
    SpinnerTypes["slim"] = "slim";
})(SpinnerTypes || (SpinnerTypes = {}));
//# sourceMappingURL=types.js.map